const WrappedError = (props) => {
    const {errors, touched, field} = props;
    if (!!errors[field] && touched[field]) {
        return <div style={{color: "#dc3545", fontSize: "0.85rem"}}>{errors[field]}</div>
    }
    return null
}

export default WrappedError;